/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/26/19
 * Time: 3:44 PM
 */
import * as actionTypes from "./actionTypes";

export const userHandler = (data) => {

  return {
    type: actionTypes.USER,
    value: data
  }
};
